import isEmpty from 'lodash/isEmpty';
import {
  convertIdToValue,
  getItemOrDefaultToValue,
  getPhoneNumber,
} from 'utils/details';
import { DEFAULT_EMPTY_VALUE } from '../../constants';
import staticFeatures from 'static/features.json';
import { t } from 'i18next';
import { AVAILABLE_RESOURCES } from 'utils/constants/plans';
import { MULTI_ROLE_SEPARATOR, ROLES } from 'utils/constants/roles';

const getTierData = securityCompanyDetail => {
  if (!securityCompanyDetail) {
    return {};
  }
  //return {key1: {type: 'text', value:''}, Key2: {type: 'icons', value:''}}
  const allResources = Object.keys(AVAILABLE_RESOURCES);
  return allResources.reduce((prev, curr) => {
    if (curr === 'features') {
      const { features } = securityCompanyDetail;
      if (!features) return [];
      // curate the icons from static file
      const availableFeaturesWithIcons = staticFeatures.filter(feature =>
        features.includes(feature.id),
      );
      Object.assign(prev, {
        [curr]: { type: 'icons', value: availableFeaturesWithIcons },
      });
    } else if (curr === 'roles') {
      const { roles } = securityCompanyDetail;
      if (!roles) return '';
      const displayRoles = roles.map(role => {
        return convertIdToValue({
          list: role,
          constant: ROLES,
          defaultValue: DEFAULT_EMPTY_VALUE,
        });
      });
      displayRoles.join(MULTI_ROLE_SEPARATOR);

      Object.assign(prev, { [curr]: { type: 'text', value: displayRoles } });
    } else if (curr === 'noOfProducts') {
      const { apiKey } = AVAILABLE_RESOURCES[curr];
      Object.assign(prev, {
        [curr]: {
          type: 'text',
          value: securityCompanyDetail.subscriptions
            ? apiKey(securityCompanyDetail.subscriptions)
            : {},
        },
      });
    }

    return prev;
  }, {});
};
const getCardString = last4 => {
  if (last4) {
    if (last4 === 'Invoiced') return last4;
    return `${t('Card ending in')} ${last4}`;
  }
  return 'None';
};

export const transform = (
  securityCompanyDetail,
  securityCompanyBillingInfo,
) => {
  const { subscriptions } = securityCompanyBillingInfo;
  const planData = getTierData(securityCompanyDetail);

  if (
    !isEmpty(securityCompanyDetail) &&
    subscriptions &&
    subscriptions.length > 0
  ) {
    return {
      currentPlan: planData,
      currentPaymentMethod: {
        cardRegistered: {
          label: 'registered_payment',
          type: 'text',
          value: securityCompanyBillingInfo.paymentMethod
            ? getCardString(
                getItemOrDefaultToValue(
                  securityCompanyBillingInfo.paymentMethod,
                  'last4',
                  '-',
                ),
              )
            : 'None',
        },
      },
    };
  } else {
    return {
      currentPlan: {
        availableResources: {
          type: 'text',
          value: 'no_subscribed_plans',
        },
      },
      currentPaymentMethod: {
        cardRegistered: {
          label: 'registered_payment',
          type: 'text',
          value: securityCompanyBillingInfo.paymentMethod
            ? getCardString(
                getItemOrDefaultToValue(
                  securityCompanyBillingInfo.paymentMethod,
                  'last4',
                  '-',
                ),
              )
            : 'None',
        },
      },
    };
  }
};

export const getCompanyProfileData = securityCompanyDetail => {
  return {
    companyName: {
      type: 'text',
      value: getItemOrDefaultToValue(securityCompanyDetail, 'name', '-'),
    },
    regionName: {
      type: 'text',
      value: getItemOrDefaultToValue(securityCompanyDetail, 'regionName', '-'),
    },
    contactEmail: {
      type: 'text',
      value:
        securityCompanyDetail.contact !== null
          ? getItemOrDefaultToValue(
              securityCompanyDetail.contact?.general,
              'email',
              '-',
            )
          : '-',
    },
    operationPhone: {
      type: 'text',
      value: securityCompanyDetail.operationPhone
        ? getPhoneNumber(securityCompanyDetail.operationPhone)
        : DEFAULT_EMPTY_VALUE,
    },
    bookingPhone: {
      type: 'text',
      value: securityCompanyDetail.bookingPhone
        ? getPhoneNumber(securityCompanyDetail.bookingPhone)
        : DEFAULT_EMPTY_VALUE,
    },
    address: {
      type: 'text',
      value: getItemOrDefaultToValue(
        securityCompanyDetail,
        'address',
        DEFAULT_EMPTY_VALUE,
      ),
    },
  };
};
